import React, { useState } from 'react'
import Menu from "../Menu";
import './apiDoc.css';

const ApiDoc = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [copiedId, setCopiedId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const endpoints = [
    {
      id: 'subuser-posid-get',
      title: 'Send Message by Subuser & POS ID',
      method: 'GET',
      endpoint: '/api/Send/Subuser/Msg/PosId',
      description: 'Send a message to a specific POS as a subuser using POS ID',
      category: 'Subuser',
      curl: `curl -X 'GET' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Subuser/Msg/PosId?apikey=abc&subuserid=1&msg=%7B%7D&clientId=123&posname=abc' \\
  -H 'accept: text/plain'`,
      parameters: [
        { name: 'apikey', type: 'string', required: true, location: 'query', description: 'API authentication key' },
        { name: 'subuserid', type: 'integer', required: true, location: 'query', description: 'Subuser identifier' },
        { name: 'msg', type: 'json', required: true, location: 'query', description: 'Message payload (URL encoded)' },
        { name: 'clientId', type: 'integer', required: true, location: 'query', description: 'Client identifier' },
        { name: 'posname', type: 'string', required: true, location: 'query', description: 'Point of Sale name' }
      ],
      response: 'text/plain'
    },
    {
      id: 'subuser-posid-post',
      title: 'Send Message by Subuser & POS ID',
      method: 'POST',
      endpoint: '/api/Send/Subuser/Msg/PosId',
      description: 'Send a message as a subuser using POST method',
      category: 'Subuser',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Subuser/Msg/PosId?subuserid=1' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: application/x-www-form-urlencoded' \\
  -d 'apikey=abc&msg=%7B%7D&clientId=123&posname=abc&allowQueue=true'`,
      parameters: [
        { name: 'subuserid', type: 'integer', required: true, location: 'query', description: 'Subuser identifier' },
        { name: 'apikey', type: 'string', required: true, location: 'body', description: 'API authentication key' },
        { name: 'msg', type: 'json', required: true, location: 'body', description: 'Message payload' },
        { name: 'clientId', type: 'integer', required: true, location: 'body', description: 'Client identifier' },
        { name: 'posname', type: 'string', required: true, location: 'body', description: 'Point of Sale name' },
        { name: 'allowQueue', type: 'boolean', required: false, location: 'body', description: 'Enable message queuing' }
      ],
      response: 'text/plain'
    },
    {
      id: 'subuser-merchant-get',
      title: 'Send Message by Subuser, Merchant & POS',
      method: 'GET',
      endpoint: '/api/Send/Subuser/Msg/MerchantName/PosName',
      description: 'Send a message as a subuser using merchant and POS names',
      category: 'Subuser',
      curl: `curl -X 'GET' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Subuser/Msg/MerchantName/PosName?apikey=abc&subuserid=1&msg=%7B%7D&clientId=123&merchantname=abc&posName=abc' \\
  -H 'accept: text/plain'`,
      parameters: [
        { name: 'apikey', type: 'string', required: true, location: 'query', description: 'API authentication key' },
        { name: 'subuserid', type: 'integer', required: true, location: 'query', description: 'Subuser identifier' },
        { name: 'msg', type: 'json', required: true, location: 'query', description: 'Message payload (URL encoded)' },
        { name: 'clientId', type: 'integer', required: true, location: 'query', description: 'Client identifier' },
        { name: 'merchantname', type: 'string', required: true, location: 'query', description: 'Merchant name' },
        { name: 'posName', type: 'string', required: true, location: 'query', description: 'Point of Sale name' }
      ],
      response: 'text/plain'
    },
    {
      id: 'subuser-merchant-post',
      title: 'Send Message by Subuser, Merchant & POS',
      method: 'POST',
      endpoint: '/api/Send/Subuser/Msg/MerchantName/PosName',
      description: 'Send a message as a subuser using POST method with merchant and POS names',
      category: 'Subuser',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Send/Subuser/Msg/MerchantName/PosName?subuserid=1&merchantname=abc&posName=abc' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: application/x-www-form-urlencoded' \\
  -d 'apikey=123&msg=%7B%7D&clientId=123&allowQueue=true'`,
      parameters: [
        { name: 'subuserid', type: 'integer', required: true, location: 'query', description: 'Subuser identifier' },
        { name: 'merchantname', type: 'string', required: true, location: 'query', description: 'Merchant name' },
        { name: 'posName', type: 'string', required: true, location: 'query', description: 'Point of Sale name' },
        { name: 'apikey', type: 'string', required: true, location: 'body', description: 'API authentication key' },
        { name: 'msg', type: 'json', required: true, location: 'body', description: 'Message payload' },
        { name: 'clientId', type: 'integer', required: true, location: 'body', description: 'Client identifier' },
        { name: 'allowQueue', type: 'boolean', required: false, location: 'body', description: 'Enable message queuing' }
      ],
      response: 'text/plain'
    },
    {
      id: 'upload-subuser-file',
      title: 'Upload File for Subuser',
      method: 'POST',
      endpoint: '/api/Upload/Subuser/File',
      description: 'Upload a file to a specified subfolder path for a subuser',
      category: 'File Upload',
      curl: `curl -X 'POST' \\
  'https://api.dqr-display-tms.bonrix.in/api/Upload/Subuser/File' \\
  -H 'accept: text/plain' \\
  -H 'Content-Type: multipart/form-data' \\
  -F 'SubUserId=123' \\
  -F 'SubFolderPath=/abc' \\
  -F 'ApiKey=123' \\
  -F 'File=@Screenshot 2025-11-05 110528.png;type=image/png'`,
      parameters: [
        { name: 'SubUserId', type: 'integer', required: true, location: 'form', description: 'Subuser identifier' },
        { name: 'SubFolderPath', type: 'string', required: true, location: 'form', description: 'Path to the subfolder where file will be uploaded (e.g., /abc)' },
        { name: 'ApiKey', type: 'string', required: true, location: 'form', description: 'API authentication key' },
        { name: 'File', type: 'file', required: true, location: 'form', description: 'File to be uploaded (supports images, documents, etc.)' }
      ],
      response: 'text/plain'
    }
  ];

  const filteredEndpoints = endpoints.filter(endpoint =>
    endpoint.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    endpoint.endpoint.toLowerCase().includes(searchTerm.toLowerCase()) ||
    endpoint.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderOverviewTab = () => (
    <div className="api-overview">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            <i className="fas fa-code"></i>
            API Documentation
          </h1>
          <p className="hero-subtitle">
            Powerful REST API for managing POS messaging across your platform
          </p>
        </div>
      </div>

      <div className="quick-stats">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fas fa-globe"></i>
          </div>
          <div className="stat-content">
            <div className="stat-label">Base URL</div>
            <div className="stat-value">api.dqr-display-tms.bonrix.in</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fas fa-plug"></i>
          </div>
          <div className="stat-content">
            <div className="stat-label">Endpoints</div>
            <div className="stat-value">{endpoints.length}</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fas fa-lock"></i>
          </div>
          <div className="stat-content">
            <div className="stat-label">Authentication</div>
            <div className="stat-value">API Key</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fas fa-file-alt"></i>
          </div>
          <div className="stat-content">
            <div className="stat-label">Response Format</div>
            <div className="stat-value">text/plain</div>
          </div>
        </div>
      </div>

      <div className="features-grid">
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-layer-group"></i>
          </div>
          <h3>Multiple Identification Methods</h3>
          <p>Target POS by ID, name, merchant name, or subuser with flexible routing options</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-exchange-alt"></i>
          </div>
          <h3>Flexible Request Methods</h3>
          <p>Full support for both GET and POST requests to suit your integration needs</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-tasks"></i>
          </div>
          <h3>Message Queuing</h3>
          <p>Optional message queuing support for reliable asynchronous processing</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-users"></i>
          </div>
          <h3>Subuser Access</h3>
          <p>Dedicated endpoints for subuser message sending with granular control</p>
        </div>
      </div>

      <div className="getting-started">
        <h2>
          <i className="fas fa-rocket"></i>
          Getting Started
        </h2>
        <div className="getting-started-content">
          <div className="step-card">
            <div className="step-number">1</div>
            <div className="step-content">
              <h4>Get Your API Key</h4>
              <p>Obtain your API key from the dashboard to authenticate your requests</p>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">2</div>
            <div className="step-content">
              <h4>Choose Your Endpoint</h4>
              <p>Select the endpoint that matches your integration requirements</p>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">3</div>
            <div className="step-content">
              <h4>Make Your First Request</h4>
              <p>Use the example curl commands to test and integrate quickly</p>
            </div>
          </div>
        </div>
      </div>

      <div className="common-params-section">
        <h2>
          <i className="fas fa-cog"></i>
          Common Parameters
        </h2>
        <div className="params-grid">
          <div className="param-card">
            <code className="param-name">apikey</code>
            <div className="param-details">
              <span className="param-type">string</span>
              <span className="param-required">Required</span>
            </div>
            <p className="param-desc">API authentication key for secure access</p>
          </div>
          <div className="param-card">
            <code className="param-name">msg</code>
            <div className="param-details">
              <span className="param-type">json</span>
              <span className="param-required">Required</span>
            </div>
            <p className="param-desc">Message payload (URL encoded in GET requests)</p>
          </div>
          <div className="param-card">
            <code className="param-name">clientId</code>
            <div className="param-details">
              <span className="param-type">integer</span>
              <span className="param-required">Required</span>
            </div>
            <p className="param-desc">Unique client identifier</p>
          </div>
          <div className="param-card">
            <code className="param-name">allowQueue</code>
            <div className="param-details">
              <span className="param-type">boolean</span>
              <span className="param-optional">Optional</span>
            </div>
            <p className="param-desc">Enable message queuing if true</p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderEndpointTab = (endpointIndex) => {
    const endpoint = endpoints[endpointIndex];
    return (
      <div className="endpoint-detail">
        <div className="endpoint-header-modern">
          <div className="endpoint-title-row">
            <div>
              <span className={`method-badge-modern method-${endpoint.method.toLowerCase()}`}>
                {endpoint.method}
              </span>
              <h2 className="endpoint-title">{endpoint.title}</h2>
            </div>
            <span className="category-badge">{endpoint.category}</span>
          </div>
          <p className="endpoint-description">{endpoint.description}</p>
          <div className="endpoint-url">
            <code>{endpoint.endpoint}</code>
          </div>
        </div>

        <div className="endpoint-body">
          <div className="code-section">
            <div className="code-header">
              <span className="code-title">
                <i className="fas fa-terminal"></i>
                Request Example
              </span>
              <button 
                className={`copy-btn ${copiedId === endpoint.id ? 'copied' : ''}`}
                onClick={() => copyToClipboard(endpoint.curl, endpoint.id)}
              >
                <i className={`fas ${copiedId === endpoint.id ? 'fa-check' : 'fa-copy'}`}></i>
                {copiedId === endpoint.id ? 'Copied!' : 'Copy'}
              </button>
            </div>
            <pre className="code-block">{endpoint.curl}</pre>
          </div>

          <div className="parameters-section">
            <h3 className="section-heading">
              <i className="fas fa-sliders-h"></i>
              Parameters
            </h3>
            <div className="params-table">
              {endpoint.parameters.map((param, idx) => (
                <div key={idx} className="param-row">
                  <div className="param-row-header">
                    <code className="param-row-name">{param.name}</code>
                    <div className="param-row-badges">
                      <span className={`location-badge location-${param.location}`}>
                        {param.location}
                      </span>
                      <span className={`required-badge ${param.required ? 'required' : 'optional'}`}>
                        {param.required ? 'Required' : 'Optional'}
                      </span>
                      <span className="type-badge-modern">{param.type}</span>
                    </div>
                  </div>
                  <p className="param-row-desc">{param.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="response-section">
            <h3 className="section-heading">
              <i className="fas fa-reply"></i>
              Response
            </h3>
            <div className="response-info">
              <div className="response-detail">
                <span className="response-label">Content-Type:</span>
                <code className="response-value">{endpoint.response}</code>
              </div>
              <div className="response-detail">
                <span className="response-label">Status:</span>
                <code className="response-value">200 OK</code>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          {/* Top Tab Navigation Bar */}
          <div className="api-navigation-wrapper">
            <div className="api-top-nav">
              <button
                className={`nav-tab ${activeTab === 'overview' ? 'active' : ''}`}
                onClick={() => setActiveTab('overview')}
              >
                <i className="fas fa-home"></i>
                <span className="tab-title">Overview</span>
              </button>
              {endpoints.map((endpoint) => (
                <button
                  key={endpoint.id}
                  className={`nav-tab ${activeTab === endpoint.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(endpoint.id)}
                >
                  <span className={`tab-method method-${endpoint.method.toLowerCase()}`}>
                    {endpoint.method}
                  </span>
                  <span className="tab-title">{endpoint.title}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="api-doc-container">
            <div className="api-sidebar">
              <div className="sidebar-header">
                <h3>Endpoints</h3>
                <div className="search-box">
                  <i className="fas fa-search"></i>
                  <input 
                    type="text" 
                    placeholder="Search endpoints..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="sidebar-menu">
                <div 
                  className={`sidebar-item ${activeTab === 'overview' ? 'active' : ''}`}
                  onClick={() => setActiveTab('overview')}
                >
                  <i className="fas fa-home"></i>
                  <span>Overview</span>
                </div>
                {filteredEndpoints.map((endpoint) => (
                  <div 
                    key={endpoint.id}
                    className={`sidebar-item ${activeTab === endpoint.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(endpoint.id)}
                  >
                    <span className={`sidebar-method method-${endpoint.method.toLowerCase()}`}>
                      {endpoint.method}
                    </span>
                    <span className="sidebar-title">{endpoint.title}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="api-content">
              {activeTab === 'overview' && renderOverviewTab()}
              {endpoints.map((endpoint, idx) => (
                activeTab === endpoint.id && (
                  <div key={endpoint.id}>
                    {renderEndpointTab(idx)}
                  </div>
                )
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApiDoc;